import { renderSmsSample } from "../../../utils/sms/smsLength";

/**
 * "≈ 124 / 160 characters · 1 WhatsApp message", like the SMS length hint.
 * Placeholders are counted with the same sample values as SMS. The limit is a
 * recommended length (same as one SMS); WhatsApp and email are never split, so
 * a longer message still costs one token.
 */
export default function MessageLengthHint({
  text,
  limit,
  unit,
}: {
  text: string;
  limit: number;
  unit: string;
}) {
  if (!String(text || "").trim()) return null;
  const length = renderSmsSample(text).length;
  const over = length > limit;

  return (
    <span className="mt-1 block text-[11px] text-slate-500 dark:text-slate-400">
      <span
        className={`font-semibold tabular-nums ${
          over ? "text-amber-600 dark:text-amber-400" : "text-slate-600 dark:text-slate-300"
        }`}
      >
        ≈ {length} / {limit} characters · 1 {unit}
      </span>
      {over ? ` — longer than ${limit} characters; keep it short like your SMS.` : ""}
    </span>
  );
}
